<template>
  <el-dialog title="新增服务事项" custom-class="add-service-diglog" width="500px" :close-on-click-modal="false" :visible.sync="visible">
    <el-form ref="form" size="small" label-width="120px" :model="form" :rules="rules">
      <el-form-item label="服务事项名称" prop="value">
        <el-input placeholder="请输入服务事项名称" v-model="form.value" maxlength="30"></el-input>
      </el-form-item>
    </el-form>
    <span slot="footer" class="invoice-footer">
      <el-button size="small" @click="handleCancel">取消</el-button>
      <el-button size="small" type="primary" @click="handleConfirm">确认</el-button>
    </span>
  </el-dialog>
</template>

<script>
export default {
  name: 'setAmount',
  data() {
    return {
      visible: false,
      form: {
        value: '',
      },
      rules: {
        value: [
          { required: true, message: '请输入服务事项名称', trigger: 'blur' },
          { min: 1, max: 30, message: '长度在 1 到 30 个字符', trigger: 'blur' },
        ],
      },
    };
  },
  methods: {
    show() {
      this.visible = true;
    },
    close() {
      this.$refs.form.resetFields();
      this.visible = false;
    },
    handleCancel() {
      this.close();
    },
    handleConfirm() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          this.$emit('confirm', this.form);
        }
      });
    },
  },
};
</script>

<style lang="less" scoped>
.add-service-diglog {
  .add-tip {
    margin-top: 24px;
    font-size: 14px;
    line-height: 22px;
    color: #ff9c00;
    > span {
      display: block;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/invoice/components/addServiceDiglog.vue